
import config from '@/config'
import banner from '@/assets/mall/spike_banner.png'
import { getProductList, getSeckill, getProduct } from '@/api/mall.js'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'

export default {
name: 'spike-list',
props: {},
components: {
Tab,
TabItem
},
data () {
return {
baseUrl: config.baseUrl,
banner,
timelist: '',
spikeList: '',
select: 0
}
},
created () { },
mounted () {
this.getSeckill()
},
methods: {

getSeckill () {
getSeckill().then(res => {
this.timelist = res.obj
if (res.obj.length > 0) {
this.getSpikelist(res.obj[0].id)
}
})
},

getSpikelist (id) {
getProduct({ id: id }).then(data => {
this.spikeList = data.obj
})
},
ontab (index, id) {
if (this.select != index) {
this.select = index
this.getSpikelist(id)
}
},

godetail (id) {
this.$router.push({ name: 'mall2ProductDetail', params: { id: id } })
}
}
}
